export type DisplayLocale = 'en' | 'ru';

/** Formats an ISO calendar date for UI without letting the device timezone shift the day. */
export function formatDisplayDate(value: string, locale: DisplayLocale): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) return value;
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
  return new Intl.DateTimeFormat(locale === 'ru' ? 'ru-RU' : 'en-US', {
    year: 'numeric',
    month: locale === 'ru' ? '2-digit' : 'short',
    day: locale === 'ru' ? '2-digit' : 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
